<template>
  <!-- 头部整体盒子 -->
      <!-- 头部顶部 -->
  <div id="header" class="container-fuild">

    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs hidden-sm">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="../../public/img/logo_black.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="newRoute == item.path?'active':''"
          @click="navClick(index,item)"
        >
         <a>
            {{item.name}}
            <span v-if="item.isChildren" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </a>
          <div class="productCenter" v-if="item.isChildren">
            <div class="producMenus">
             <dl>
                 <dt>阳光研学</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/DomesticStudy')">国内路线</li>
                      <li @click="producAuth('/productCenter/internationalStudy')">国外路线</li>
                    </ul>
                 </dd>
             </dl>
             <dl>
                 <dt>综合实践</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/ComprehensivePractice?type=1')">校外活动</li>
                      <li @click="producAuth('/productCenter/ComprehensivePractice?type=2')">校内活动</li>
                      <li  @click="producAuth('/productCenter/ComprehensivePractice?type=3')">公益活动</li>
                    </ul>
                 </dd>
             </dl>
             <dl>
                 <dt>课后服务</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/curriculumSystem')">课程体系</li>
                      <li @click="goOutside('https://www.cqedu.online/#/talk')">在线客服</li>
                    </ul>
                 </dd>
             </dl>
             <!-- <dl>
                 <dt>综合素质提升</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/studyPlan')">升学规划</li>
                      <li @click="producAuth('/productCenter/talent')">背景提升&指尖人才培养</li>
                      <li @click="producAuth('/productCenter/ArtCompetition')">艺考培训&赛事集训</li>
                      <li @click="producAuth('/productCenter/physicalEducation')">体教融合</li>
                    </ul>
                 </dd>
             </dl>
             <dl>
                 <dt>教师培训&课题研究</dt>
                 <dd>
                    <ul>
                      <li @click="producAuth('/productCenter/teacherTrain')">教师培训</li>
                      <li @click="producAuth('/productCenter/research')">课题研究</li>
                    </ul>
                 </dd>
             </dl> -->
           
          </div>
          </div>
          <!-- <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl> -->
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs visible-sm">
      <div class="header-nav-m-head">
          <div class="header-nav-m-option"  @click="menuClick"  data-toggle="collapse" data-target="#menu">
            <img src="../../public/img/option.png" alt="">
          </div>
          <div class="header-nav-m-logo">
            <img class="center-block" src="../../public/img/logo_black.png" alt="logo">
          </div>
          <div></div>
      </div>
      
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center" 
          >
        <!-- {{menuName}} -->
        <!-- <div
          class="header-nav-m-menu-wrapper"
        >
          <span :class="menuClass"></span>
        </div> -->
        <!-- 导航内容 -->
        <!-- 
            -->
        <div id="menu" class="header-nav-m-wrapper collapse">
            <div v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item)"
            data-toggle="collapse"
            :data-target="index !=3?'#menu':''" 
            >
             <div class="navigation">
              {{item.name}}
              <i class="glyphicon glyphicon-menu-right downIcon" v-show="item.phoneChilderen&&!isDownFalse"></i>
              <i class="glyphicon glyphicon-menu-down downIcon" v-show="item.phoneChilderen&&isDownFalse"></i>
              <i class="underline"></i>
            </div>
            <!-- {{ item.children }} -->
            <div  v-for="(val,i) in item.phoneChilderen" :key="i"  data-toggle="collapse" data-target="#menu" v-show="isDownFalse">
              <div class="navigation  navigationChild"    @click="childerenClick(i,val)"  
              >
                  {{val.name}}
                  <i class="underline"></i>
                </div>
                <div class="navigation navigationChild" v-for="(str,sub) in val.children" :key="sub">
                    {{str.name}}
                </div>
            </div>
            <!-- v-if="item.children" :items="item.children" -->
          </div>
        </div>
        <!-- <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <span>
              {{item.name}}
              <i class="underline"></i>

                <li>666666666</li>
            </span>
           
          </li> -->
        <!-- </ul> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/home",
          children: [],
          isChildren:false
        },
        {
          name: "阳光概况",
          path: "/summarySunshine",
          children: []
        },
        {
          name: "热点资讯",
          path: "/hotNew",
          children: [],
          isChildren:false
        },
        {
          name: "产品中心",
          path: "/newsinformation",
          children: [
          ],
          phoneChilderen: [
          {
              name: "国内线路",
              path: "/productCenter/DomesticStudy",
              children: [],
              isChildren:false
            },
            {
              name: "国外线路",
              path: "/productCenter/internationalStudy",
              children: []
            },
            {
              name: "校外活动",
              path: "/productCenter/ComprehensivePractice?type=1",
              children: [],
              isChildren:false
            },
            {
              name: "校内活动",
              path: "/productCenter/ComprehensivePractice?type=2",
              children: []
            },
            {
              name: "公益活动",
              path: "/productCenter/ComprehensivePractice?type=3",
              children: [],
              isChildren:false
            },
            {
              name: "课程体系",
              path: "/productCenter/curriculumSystem",
              children: []
            },
            
          ],
          isChildren:true
        },
        {
          name: "服务支持",
          path: "/service",
          children: [],
          isChildren:false
        },
        {
          name: "下载中心",
          path: "/downloadCenter",
          children: [],
          isChildren:false
        },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
      newRoute: '/',
      isDownFalse:false
    };
  },
  mounted() {
    console.log(this.$route)
    
  },
  methods: {
    navClick(index, item) {
      if (item.phoneChilderen&&item.phoneChilderen.length > 0) {
        this.isDownFalse = !this.isDownFalse
        return
      } else {
        if (this.$route.path == item.path) {
          return
        }
        this.navIndex = index;
        sessionStorage.setItem('navIndex',index)
        this.menuName = item.name;
        this.$router.push({  path: item.path })
       }
    },
    childerenClick(index, item) {
      if (this.$route.path == item.path) {
          return
        }
        this.$router.push({  path: item.path })
     
    },
    
    producAuth(path) {
      if (this.$route.path == path) {
        return
      }
      this.$router.push({  path: path })
    },
    goOutside(url) {
     window.open(url, '_blank');
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  },
  watch: {
    '$route'(to, from) {
      // 路由变化时会触发这个函数
      // 'to' 和 'from' 是两个路由对象，可以用来获取即将进入和离开的路由信息
      this.newRoute = to.path
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #E1892A;
  position: relative;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items:center
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 180px;
  height: 70px;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 180px;
  height: 70px;

}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 90px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 25px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
  cursor: pointer;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #E1892A;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li:hover a{
  color: #E1892A;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
#header .header-nav .header-nav-wrapper > li:hover .productCenter {
  display: block;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #E1892A;
  text-decoration: none;
  border-bottom: 2px solid #E1892A;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
.productCenter{
    position: absolute;
    width: 420px;
    background: #fff;
    left: -170px;
    border: 2px solid #E1892A;
    display: none;
    z-index: 99999;
}
.producMenus{
  display: flex;
  justify-content: space-around;
}
.producMenus dl{
  float: left;
  margin-top: 20px;
}
.producMenus dl:nth-child(4){
  margin-right: 0;
}
.producMenus dt{
  font-size: 16px;
  color: #333333;
  line-height: 20px;
  height: 20px;
  margin-bottom: 28px;
  position: relative;
}

.producMenus dd {
    font-size: 14px;
    line-height: 35px;
    color: #666666;
    cursor: pointer;
}
.producMenus dd ul li:hover{
    color: #E1892A;
}
.downIcon{
  position: absolute;
  color: #333333;
  top: 12px;
  right: 115px
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
    
  }
.header-nav-m-head{
    height: 80px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  #header .header-nav-m .header-nav-m-option {
   width: 25px;
   height: 25px;
 }
 #header .header-nav-m .header-nav-m-option img{
   width: 25px;
   height: 25px;
 }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
   
    
    /* display: flex; */
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 170px;
    height: 66px;
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto; */
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 0px;
    font-size: 20px;
    line-height: 50px;
    background: #E1892A;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper .navigation {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
    color: #333;
    font-size: 16px;
    position: relative;

  }
  #header .header-nav-m .header-nav-m-wrapper .navigationChild{
    font-size: 14px !important;
    color: #666 !important;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  /* #header .header-nav-m .header-nav-m-wrapper > .navigation > span {
    color: #333;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
    cursor: pointer;
  } */
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > .navigation > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue